<template>
    <div class="row align-items-md-stretch pb-5">
        <div class="col-md-6">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Gestione Tipologie Di Esercizi</h2>
                <p>Visualizzazione, aggiunta e modifica delle tipologie di esercizi</p>
                <a :href="route('tipo_esercizio.index')" class="btn btn-outline-dark"
                    >Vai</a
                >
            </div>
        </div>
        <div class="col-md-6">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Gestione Esercizi</h2>
                <p>Visualizzazione, aggiunta e modifica degli esercizi</p>
                <a :href="route('esercizi.index')" class="btn btn-outline-dark"
                    >Vai</a
                >
            </div>
        </div>
    </div>

    <div class="row align-items-md-stretch pb-5">
        <div class="col-md-6">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Gestione Attrezzi</h2>
                <p>Visualizzazione, aggiunta e modifica degli attrezzi.</p>
                <a :href="route('attrezzo.index')" class="btn btn-outline-dark"
                    >Vai</a
                >
            </div>
        </div>
        <div class="col-md-6">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Gestione Tipologie Di Test</h2>
                <p>Visualizzazione, aggiunta e modifica delle tipologie di test</p>
                <a :href="route('tipo_test.index')" class="btn btn-outline-dark"
                    >Vai</a
                >
            </div>
        </div>
    </div>

    
</template>
<script>
import Main from "@/Layouts/Main.vue";

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);
    },
};
</script>
